module.exports = __webpack_public_path__ + "img/3.9.TU.1c281aa4.png";